import { BrandLogo } from "@/components/BrandLogo";
import { THC } from "@/lib/tankHealthCheck";

const NAV = [
  ["How It Works", "how-it-works"],
  ["What We Check", "what-we-check"],
  ["Book", "book"],
  ["About Us", "about-us"],
];

export function CampaignHeader({ onBook, onNav }) {
  return (
    <header className="sticky top-0 z-40 bg-white border-b border-[#D6E8F2]"
      data-testid="thc-header">
      <div className="mx-auto max-w-[1440px] px-[18px] md:px-7 xl:px-10">
        <div className="h-[68px] md:h-[80px] flex items-center gap-4">
          <div className="shrink-0 w-[170px] md:w-[225px]">
            <BrandLogo to="/" size="md" className="!h-9 md:!h-12" />
          </div>
          <nav className="hidden lg:flex items-center gap-7 ml-6">
            {NAV.map(([label, id]) => (
              <button key={id} onClick={() => onNav(id)}
                data-testid={`thc-nav-${id}`}
                className="text-[15px] xl:text-[16px] font-semibold text-[#173452] hover:text-[#0877CC] transition-colors">
                {label}
              </button>
            ))}
          </nav>
          <button onClick={onBook} data-testid="thc-header-cta"
            className="ml-auto h-[44px] md:h-[48px] px-3.5 md:px-6 rounded-[8px] text-white text-[13px] md:text-[16px] font-bold whitespace-nowrap transition-transform hover:-translate-y-0.5"
            style={{ backgroundColor: THC.blue }}>
            <span className="sm:hidden">BOOK NOW</span>
            <span className="hidden sm:inline">BOOK MY HEALTH CHECK</span>
          </button>
          <div className="hidden xl:block pl-6 border-l border-[#D6E8F2] text-right leading-tight">
            <div className="text-[11px] font-bold tracking-wide" style={{ color: THC.muted }}>CLEANER WATER</div>
            <div className="text-[11px] font-bold tracking-wide" style={{ color: THC.muted }}>BRIGHTER TOMORROWS</div>
          </div>
        </div>
      </div>
    </header>
  );
}
